import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE4,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import { defaultToastError, isNull } from "App/utils/helpers";
import { useContext } from "react";
import { FormContext } from "../context/FormContext";
export default function ModalBarang({
  formBarang,
  setFormBarang,
  setNewDataReqList,
  setListREQ,
  listREQ,
  namaInputRef,
}) {
  const { disabled, setDisabled } = useContext(FormContext);
  const { setShowModalBarang } = useContext(FormContext);
  
  const satuan = useSelectOption(
    true,
    "/wmsMasterAsset/satuan/list",
    TYPE_INSTANCE4
  );
  const golonganBarang = useSelectOption(
    true,
    "/wmsMasterAsset/golongan/get_golongan",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (
      isNull(formBarang.qty) ||
      isNull(formBarang.name_barang) ||
      isNull(formBarang.satuan_id) ||
      isNull(formBarang.golongan_id)
    ) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Harap lengkapi data barang !");
    } else {
      try {
        const barang = listREQ;
        const checkBarang = barang.filter((e) => e.id === formBarang.id);
        if (checkBarang.length === 0) {
          const checkNamaBarang = barang.filter(
            (e) => e.name_barang === formBarang.name_barang
          );
          if (checkNamaBarang.length === 0) {
            const barang = listREQ;
            barang.push({
              id: null,
              name_barang: formBarang?.name_barang,
              namasatuan: formBarang?.namasatuan,
              namagolongan: formBarang?.namagolongan,
              satuan_id: formBarang?.satuan_id,
              golongan_id: formBarang?.golongan_id,
              qty: formBarang.qty,
              remark: formBarang?.remark,
              status_cek_barang : null,
              keterangan_cek_barang : null,
              user_cek_barang : null,
              dateCek : null,
            });
            setListREQ(barang);
          } else {
            defaultToastError("Tidak dapat menambahkan barang yang sama !");
          }
        } else {
          const barang = listREQ;
          const checkBarang = barang.filter(
            (e) => e.name_barang !== formBarang.name_barang
          );
          checkBarang.push({
            id: formBarang?.id,
            name_barang: formBarang?.name_barang,
            namasatuan: formBarang?.namasatuan,
            namagolongan: formBarang?.namagolongan,
            satuan_id: formBarang?.satuan_id,
            golongan_id: formBarang?.golongan_id,
            qty: formBarang.qty,
            remark: formBarang.remark,
            status_cek_barang : null,
            keterangan_cek_barang : formBarang.keterangan_cek_barang,
            user_cek_barang : formBarang.user_cek_barang,
            dateCek : formBarang.dateCek,
          });
          setListREQ(checkBarang);
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModalBarang(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  // const succesCreateOrUpdate = async (label) => {
  //   defaultToastSuccess(`Berhasil ${label} Barang`);
  //   const res = await getReqListById(formData.idReq);
  //   setListREQ(res.data);

  // };
  return (
    <Modal title={`Tambah Barang`} show={setShowModalBarang} width="80%">
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="barang_id"
            id="barang_id"
            readOnly={true}
            value={formBarang?.barang_id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name="namabarang"
              label="NAMA BARANG"
              id="namabarang"
              value={formBarang?.name_barang}
              onChange={handleChange("name_barang")}
              placeholder="Nama Barang"
              inputRef={namaInputRef}
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="satuan_id"
              label="SATUAN"
              id="satuan_id"
              withSearch={true}
              data={satuan}
              value={formBarang?.satuan_id}
              labelValue={formBarang?.namasatuan}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormBarang({
                    ...formBarang,
                    satuan_id: null,
                    namasatuan: "Pilih Satuan",
                  });
                } else {
                  setFormBarang({
                    ...formBarang,
                    satuan_id: e.value,
                    namasatuan: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="qty"
              label="BANYAK"
              id="qty"
              value={formBarang?.qty}
              onChange={handleChange("qty")}
              placeholder="Banyak"
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="golongan_id"
              label="GOLONGAN BARANG"
              id="golongan_id"
              withSearch={true}
              data={golonganBarang}
              value={formBarang?.golongan_id}
              labelValue={formBarang?.namagolongan}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormBarang({
                    ...formBarang,
                    golongan_id: null,
                    namagolongan: "Pilih Golongan",
                  });
                } else {
                  setFormBarang({
                    ...formBarang,
                    golongan_id: e.value,
                    namagolongan: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name="remarkBarang"
              label="Catatan"
              id="remarkBarang"
              value={formBarang?.remark}
              onChange={handleChange("remark")}
              placeholder="Catatan"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
}
